module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.canBeEvaluated) ? _c('div', _vm._l((_vm.paper.event_paper_type.evaluation_types), function(evaluationType) {
    return (_vm.canBeApproved) ? _c('table', {
      staticClass: "table-confirmation table-evaluations"
    }, [_c('thead', [_c('tr', [_c('th', [_c('span', [_vm._v(_vm._s(evaluationType.evaluation_type.name) + " /")]), _vm._v(" "), _c('span', [_vm._v("De: " + _vm._s(_vm._f("dateTimeEnToBr")(evaluationType.start_datetime)))]), _vm._v(" "), _c('span', [_vm._v("a " + _vm._s(_vm._f("dateTimeEnToBr")(evaluationType.end_datetime)))]), _vm._v(" "), (evaluationType.evaluation_finished) ? _c('el-tag', {
      attrs: {
        "size": "small",
        "type": "danger"
      }
    }, [_vm._v("\n                    Finalizada\n                ")]) : _vm._e(), _vm._v(" "), (evaluationType.evaluation_opened) ? _c('el-tag', {
      attrs: {
        "size": "small",
        "type": "success"
      }
    }, [_vm._v("\n                    Em andamento\n                ")]) : _vm._e(), _vm._v(" "), (!evaluationType.evaluation_opened && !evaluationType.evaluation_finished) ? _c('el-tag', {
      attrs: {
        "size": "small",
        "type": "info"
      }
    }, [_vm._v("\n                    Não disponível\n                ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [(_vm.paper) ? _c('paper-show-evaluation-responses', {
      attrs: {
        "paper": _vm.paper,
        "evaluation-type": evaluationType,
        "reviews": _vm.reviews(evaluationType.id)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.paper) ? _c('paper-show-evaluation-appraisers', {
      attrs: {
        "paper": _vm.paper,
        "evaluation-type": evaluationType,
        "reviews": _vm.reviews(evaluationType.id)
      }
    }) : _vm._e()], 1)])])]) : _vm._e()
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36ae79e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/paper/Evaluation.vue
// module id = 740
// module chunks = 2